export const formatZipForMeta = zip => zip?.substring(0, 5) ?? undefined;

export const formatCityForMeta = city => {
  const regex = /[^a-zA-Z]/gi;
  return city?.toLocaleLowerCase('en-US').replaceAll(regex, '') ?? undefined;
};

export const formatStateForMeta = state => state?.toLowerCase() ?? undefined;
